/**
 * Espelha OportunidadeOcorrenciaEditarRequest da API CRM (PUT Oportunidade/idOportunidade/{idOportunidade}/ocorrencia/
 * {idOportunidadeOcorrencia}): nova descrição de uma anotação (5) ou ação concluída (22). O escopo de vendedores é
 * posto pelo orquestrador.
 */
export class OportunidadeOcorrenciaEditarRequest {
  /** Texto do registro, até 1000 caracteres. */
  descricao: string;
}
